
import { Component, Vue } from "vue-property-decorator";
import tigermaster from "fdtigermaster-client-sdk";

@Component({
  components: {},
})
export default class RechargePayment extends Vue {
  //data
  isLoading = true;
  proInfo: { userName: string; description: string; amount: number } = {
    userName: "",
    description: "",
    amount: 0
  };
  paymentInfo: { tradeInfo: string; tradeSha: string; version: string; merchantID: string; encryptType: number | null } = {
    tradeInfo: "",
    tradeSha: "",
    version: "",
    merchantID: "",
    encryptType: null,
  };

  $refs!: {
    form: HTMLFormElement;
  };

  //hook
  mounted(): void {
    this.getinfo();
  }

  //computed
  get action(): string {
    return process.env.VUE_APP_NEWEBPAY_URL as string;
  }
  
  //methods
  async getinfo(): Promise<any> {
    this.isLoading = true;
    try {
      let paymentId: string = this.$route.query.paymentId as string;
      let accessToken: string = this.$route.query.accessToken as string;
      tigermaster.auth.loginWithTempToken(accessToken);
      this.proInfo = (await tigermaster.recharge.confirmRechargePayment(paymentId)) as any;
      this.paymentInfo = (await tigermaster.recharge.directRechargePayment(paymentId)) as any;
    } catch (err) {
      console.error(err);
    } finally {
      this.isLoading = false;
    }
  }
  Submit(): void {
    this.$refs.form.submit();
  }
}
